<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';
useCheckLandingContent();
const { setReserveType } = useSearchFormStore();
onMounted(() => setReserveType(ReserveType.Train));
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط قطار', link: '/train-ticket' },
        { title: 'بلیط قطار $cityName', link: '$routePath' },
    ]),
});
</script>
<template>
    <InformationContainer />
</template>
